import  { AxiosResponse } from 'axios';
import { GET_ACCOUNT_INFO_URL, UPDATE_COORDS_URL } from '../utils/environment';
import { AccountInformation } from '../types/manageAccount.type';
import axiosInstance from '../utils/axiosInstance';

class ManageAccountService {
  static async getAccountInfoAsync(RCN: string, token:string): Promise<AccountInformation | null> {
    try {
      if (!RCN) {
        throw new Error('getAccountInfoAsync: RCN is required');
      }

      const response: AxiosResponse = await axiosInstance.post(
        `${GET_ACCOUNT_INFO_URL}/${RCN}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      );

      if (!response || !response.data) {
        throw new Error('getAccountInfoAsync: Received invalid response from server');
      }

      let accountInfomation: AccountInformation[] = response.data;

      if (!accountInfomation || !accountInfomation.length) {
        throw new Error('getAccountInfoAsync: Received empty response from server');
      }

      return accountInfomation[0];
    } catch (error) {
      console.error('Error in getAccountInfoAsync: ', error);
      return null;
    }
  }

  static async addCoordsAsync(RCN: string, token:string, lat: any, lon: any): Promise<boolean> {
    try {
      let data = {
        rcn: RCN,
        latitude: lat,
        longitude: lon,
      };

      if (!RCN || !lat || !lon) {
        throw new Error('addCoordsAsync: RCN, lat and lon are required');
      }

      const response: AxiosResponse | undefined = await axiosInstance.post(`${UPDATE_COORDS_URL}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response || !response.data) {
        throw new Error('addCoordsAsync: Received invalid response from server');
      }

      let accountInfomation: {
        Status: boolean;
      } | null = response?.data;

      if (!accountInfomation || !accountInfomation.Status) {
        throw new Error('addCoordsAsync: Received empty response from server');
      }

      return accountInfomation.Status;
    } catch (error) {
      console.error('Error in addCoordsAsync: ', error);
      return false;
    }
  }
}

export default ManageAccountService;
